import classNames from "classnames";
import { IconButton } from "components";
import { toast } from "react-toastify";

export const notify = (data: {
  message: string;
  type: "success" | "error";
}) => {
  toast(
    <div className="flex items-center justify-center max-md:mt-6">
      <div className="w-[270px] p-2 rounded-xl border border-gray-300 bg-white font-['iranyekanFaNum']">
        <div className="flex justify-between text-lg font-bold">
          <span
            className={classNames({
              ["text-error"]: data.type == "error",
              ["text-success"]: data.type == "success",
            })}
          >
            {data.type == "success" ? "موفقیت آمیز" : "خطا"}
          </span>
          <IconButton size="xs" backgroundColor={"#F2F2F2"} iconName="XMark" />
        </div>
        <div className="text-sm text-gray-400 whitespace-pre-line">
          {String(data.message)}
        </div>
      </div>
    </div>
  );
};
